import React, { FC, useEffect, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { Button, Col, Row, Select, Spin } from "antd";
import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import moment from "moment";
import { IResultResponse } from "../../models/response/result.model";
import { ILayoutRibbon } from "../../models/layout-ribbon.model";
import HighChartsService from "../../services/highcharts.service";
import RequestsService from "../../services/requests.service";
import ChartRangeSelector from "../CI10/ChartRangeSelector";
import { PeriodIndexTypes, PeriodTypesArray } from "../../services/enums";

const ComparativePerformance: FC = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({
    result: [],
  });
  const [selectedIds, setSelectedIds] = useState<any[]>([1, 2]);
  const [periodIndex, setPeriodIndex] = useState(PeriodIndexTypes["1m"]);

  const { fetchedData: instruments, loading: instrumentsLoading } = useHttpGet<
    IResultResponse<ILayoutRibbon[]>
  >(`${APIRoutes.LAYOUT_RIBBON}`, {
    defaultValue: {
      result: [] as ILayoutRibbon[],
    },
  });

  useEffect(() => {
    compare();
  }, []);

  useEffect(() => {
    compare();
  }, [periodIndex]);

  const compare = async () => {
    setLoading(true);

    const response = await RequestsService.getMethod<IResultResponse<any>>(
      `${APIRoutes.CRYPTO_MARKETS_COMPATIVE_PERFORMANCE}`,
      { period: PeriodTypesArray[periodIndex], instrumentIds: selectedIds.filter(f => f > 0), indexIds: selectedIds.filter(f => f < 0).map(f => -f) }
    );

    setData(response.data);
    setLoading(false);
  };

  const getOptions = (data: any[], title: string) => {
    return {
      ...HighChartsService.baseSettings({
        title: {
          text: "Comparative Performance",
        },
        subtitle: {
          text:
            data?.length > 0
              ? `updated on ${moment(data[data?.length - 1]?.updatedOn).format(
                "MM/DD/YYYY HH:mm"
              )}`
              : "",
        },
        legend: {
          enabled: false,
        },
        series: data?.map((el) => ({
          name: el?.name,
          data: CommonService.sortByDate(el?.values, "item1")?.map(
            (el: any) => [moment(el?.item1).unix() * 1000, el?.item2]
          ),
        })),
      }),
    };
  };

  return (
    <Spin spinning={loading || instrumentsLoading}>
      <Row justify="center" align="top">
        <Col xs={24} sm={16} md={18}>
          <ChartRangeSelector
            periodIndex={periodIndex}
            setPeriodIndex={setPeriodIndex}
          />
          <HighchartsReact
            constructorType={"stockChart"}
            highcharts={Highcharts}
            options={getOptions(
              data?.result?.changePerscentComparativeChart || [],
              "COMPARATIVE PERFORMANCE"
            )}
          />
        </Col>

        <Col xs={24} sm={8} md={6}>
          <Select
            mode="multiple"
            allowClear
            style={{ minWidth: "15em" }}
            defaultValue={selectedIds}
            placeholder="Please select at least instruments"
            onChange={(val: any[]) => {
              setSelectedIds(val);
            }}
          >
            {instruments?.result?.map((el: ILayoutRibbon) => (
              <Select.Option key={el.idInstrument ?? el.indexId} value={el.idInstrument ?? (-el.indexId)}>
                {el.name}({el.ticker})
              </Select.Option>
            ))}
          </Select>

          <Button onClick={compare} disabled={selectedIds.length < 2} block type="primary" className="mt-2">
            Compare
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};

export default ComparativePerformance;
